import { SR_API_ACTION_ID_VERIFICATION_VOUCHED_VERIFICATION_FLOW_SUBMIT } from 'api/actionTypes';

import getByUserSessionAction from 'client/actions/IdVerifications/getByUserSession';
import loadRenterProfileAction from 'client/actions/Household/loadRenterProfile';

export default async function submit({ state, apiClient }, { vouchedToken, idVerificationFlow }) {
  const currentUserId = state.get(['currentUser', 'id']);

  const idVerification = await apiClient.postWithState({
    action: SR_API_ACTION_ID_VERIFICATION_VOUCHED_VERIFICATION_FLOW_SUBMIT,
    state: state,
    payload: {
      vouchedToken: vouchedToken,
      idVerificationFlow,
    },
  });

  await Promise.all([
    getByUserSessionAction({ state, apiClient }, { forceRefresh: true }),
    loadRenterProfileAction({ state, apiClient }, { userId: currentUserId, forceRefresh: true }),
  ]);

  return idVerification;
}
